import React from "react";
import { Frame } from "../../../assets/images";

type FAQProps = {
  faq: {
    id: number;
    question: string;
    answer: string;
  };
  index: number;
  showFaq: number;
  setShowFaq: React.Dispatch<React.SetStateAction<number>>;
};

const FAQ: React.FC<FAQProps> = ({ faq, index, showFaq, setShowFaq }) => {
  return (
    <div
      className="flex flex-col justify-center gap-2 px-4 py-2 md:px-6 md:py-3 bg-white border rounded-lg md:rounded-xl cursor-pointer"
      key={index}
      onClick={() => {
        if (showFaq === faq.id) {
          setShowFaq(0);
        } else {
          setShowFaq(faq.id);
        }
      }}
    >
      <div className="flex justify-between  items-center">
        <div className="font-Inter text-[#0E0B3D] text-[9px] md:text-[16px] font-medium leading-8 ">
          {faq.question}
        </div>
        <img src={Frame} alt="" />
      </div>
      <div className="">
        {showFaq === faq.id && (
          <div className="px-4 py-2 md:px-6 md:py-3 bg-white border rounded-xl">
            <div className="font-Inter text-[#0E0B3D] text-[9px] md:text-[16px] font-medium md:leading-8 ">
              {faq.answer}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQ;
